export default "__VITE_PUBLIC_ASSET__1495a34c__"